import {
  Flex,
  Grid,
  Page,
  PageContent,
  PageHeader,
  PageHeaderActions,
  PageHeaderTitle,
  PageHeaderTop,
  Skeleton,
  Stack,
  csx,
} from '@vtex/admin-ui'

export function Loading() {
  return (
    <Page>
      <PageHeader>
        <PageHeaderTop>
          <PageHeaderTitle>
            <Skeleton className={csx({ height: 40, width: 200 })} />
          </PageHeaderTitle>
          <PageHeaderActions>
            <Skeleton className={csx({ width: 100, height: 44 })} />
            <Skeleton className={csx({ width: 100, height: 44 })} />
          </PageHeaderActions>
        </PageHeaderTop>
      </PageHeader>
      <PageContent layout="narrow">
        <Flex justify="space-between">
          <Skeleton className={csx({ height: '3rem', width: '30%' })} />
          <Skeleton className={csx({ height: '3rem', width: '10%' })} />
        </Flex>

        <Stack space="$space-6" className={csx({ marginY: '$space-5' })}>
          <Skeleton className={csx({ height: '3rem', width: 'full' })} />
          <Skeleton className={csx({ height: '5rem', width: 'full' })} />
        </Stack>

        <Grid templateColumns="1fr 1fr" columnGap="1rem" rowGap="1.5rem">
          <Skeleton className={csx({ height: '3rem', width: 'full' })} />
          <Skeleton className={csx({ height: '3rem', width: 'full' })} />
          <Skeleton className={csx({ height: '3rem', width: 'full' })} />
          <Skeleton className={csx({ height: '3rem', width: 'full' })} />
        </Grid>

        <Skeleton
          className={csx({
            height: '3rem',
            width: '40%',
            marginY: '$space-8',
          })}
        />

        <Grid
          templateAreas={['a a', 'b c']}
          templateRows="1fr 1fr"
          columnGap="1rem"
          rowGap="1.5rem"
        >
          <Skeleton
            className={csx({ height: '3rem', width: '5/12', gridArea: 'a' })}
          />

          <Skeleton
            className={csx({ height: '3rem', width: 'full', gridArea: 'b' })}
          />
          <Skeleton
            className={csx({ height: '3rem', width: 'full', gridArea: 'c' })}
          />
        </Grid>
      </PageContent>
    </Page>
  )
}
